import { SelectListItem } from "../utilities/selectlist-item";

export enum ShippingMethod {
    Delivery = 0,
    Pickup = 1,
}

export const ShippingMethodMetadata = {
    '0': {
        display: 'Delivery',
        value: 0
    },
    '1': {
        display: 'Pickup',
        value: 1
    }
};

const ShippingMethodSelectList = new Array<SelectListItem<string>>();
ShippingMethodSelectList.push(new SelectListItem({ id: '0', name: 'Delivery' }));
ShippingMethodSelectList.push(new SelectListItem({ id: '1', name: 'Pickup' }));

export { ShippingMethodSelectList }